__turbopack_context__.v({
  "contents": "kHoVba_contents",
  "description": "kHoVba_description",
  "row": "kHoVba_row",
  "subtitle": "kHoVba_subtitle",
  "threeColRow": "kHoVba_threeColRow",
  "title": "kHoVba_title",
  "titleLink": "kHoVba_titleLink",
});
